import LScreen from "@components/LScreen";
import { ActivityIndicator } from "react-native";
import React from "react";

const LoadingScreen = () => {
  return (
    <LScreen
      alignItems="center"
      enableAutomaticBottomPadding={true}
      enableAutomaticTopPadding={true}
      justifyContent="center"
    >
      <ActivityIndicator size="large" />
    </LScreen>
  );
};

export default LoadingScreen;
